import type { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { getMainHost } from '@xing-com/crate-login-utils';
import { useHost } from '@xing-com/crate-xinglet';

import { Styled } from './background-layout.styles';
import energizer from './images/energizer.jpeg';
import hiddenJobs from './images/hidden-jobs.png';

export const BackgroundLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { formatMessage } = useIntl();
  const { getHostname } = useHost();
  const mainHost = getMainHost(getHostname());
  const { getSearchParameter } = useSearchParameter();
  const hasHiddenJobsParam =
    getSearchParameter('dest_url')?.includes('hidden-jobs');

  return (
    <>
      <Styled.TopBar showOnSmallerScreens />

      <Styled.LoginContainer>
        <Styled.ColumnWithBackground>
          <Styled.LogoLink
            href={mainHost}
            aria-label={formatMessage({ id: 'A11Y_LOGO' })}
          >
            <Styled.XingLogo variant="mono" size={96} />
          </Styled.LogoLink>
          <Styled.Energizer
            src={hasHiddenJobsParam ? hiddenJobs : energizer}
            alt=""
            loading="lazy"
          />
        </Styled.ColumnWithBackground>
        <Styled.MainWrapper>
          <Styled.Column>{children}</Styled.Column>
        </Styled.MainWrapper>
      </Styled.LoginContainer>
    </>
  );
};
